import { AxiosInstance } from "axios";
import type { MondayBoard } from "./MondaySourceSettings.types";

export class MondaySourceSettingsApi {
  constructor(private readonly client: AxiosInstance) {}

  async getBoards(boardId: string, connectionId: string): Promise<MondayBoard[]> {
    const response = await this.client.get<MondayBoard[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/monday/boards`,
    );

    return response.data;
  }
}
